module.exports = __webpack_public_path__ + "img/uk-retail-4.6387a389.png";